import { Controller } from 'stimulus';
// import Rails from '@rails/ujs';

import * as AgGrid from 'ag-grid-community';
import {Datasource} from '@core/core/grid/datasource';
import {
  DEFAULT_GRID_OPTIONS,
  buildColumnDefs,
  updateColumnPositionsInCookies,
} from '@core/core/grid/utils';

var columnOptions = {
  columnDefs: {
    account_name: { cellClass: 'font-mono cursor-pointer', maxWidth: 200, tooltipField: 'account_name' },
    amount_html: {
      cellClass: 'font-mono cursor-pointer text-right',
      headerClass: 'ag-header-cell ag-header-cell-sortable text-xs font-medium text-gray-500 uppercase bg-gray-100'
                   + ' ag-focus-managed ag-right-aligned-header',
      maxWidth: 200,
      sortable: true,
    },
    created_at: { cellClass: 'font-mono cursor-pointer', sortable: true },
    fingerprint: { cellClass: 'font-mono cursor-pointer', maxWidth: 150 },
    order_id: { cellClass: 'font-mono cursor-pointer', sortable: false },
    payment_instrument_html: {
      cellClass: 'p-0 mt-0 cursor-pointer', maxWidth: 30, sortable: true, withoutHeader: true,
    },
    payment_status_html: { cellClass: 'font-mono cursor-pointer', maxWidth: 150, sortable: true },
    processing_status_html: { cellClass: 'font-mono cursor-pointer', sortable: true },
    distribution_account_names: {
      cellClass: 'font-mono cursor-pointer', maxWidth: 200, sortable: true, tooltipField: 'distribution_account_names'
    },
    refunds_text: { cellClass: 'font-mono cursor-pointer', maxWidth: 200, sortable: true },
    settled_at: { cellClass: 'font-mono cursor-pointer', sortable: false },
    status_html: { cellClass: 'cursor-pointer', maxWidth: 55, sortable: true, withoutHeader: true },
    updated_at: { cellClass: 'font-mono cursor-pointer', sortable: true }
  },
  defaultSorting: [
    'status_html',
    'payment_instrument_html',
    'updated_at',
    'created_at',
    'fingerprint',
    'account_name',
    'distribution_account_names',
    'order_id',
    'payment_status_html',
    'processing_status_html',
    'settled_at',
    'amount_html',
    'refunds_text',
  ],
};

const cookiesChecksum = JSON.stringify(columnOptions.defaultSorting).length;
columnOptions.cookiesName = `payments_columns_positions_${cookiesChecksum}`;

function buildGrid(gridElement, dataCallbacks) {
  const {
    allowedColumnsJson,
    i18nJson,
    indexPath,
    paginationPageSize,
  } = gridElement.dataset
  const options = {
    ...DEFAULT_GRID_OPTIONS,
    cacheBlockSize: paginationPageSize,
    columnDefs: buildColumnDefs(columnOptions, {
      allowedColumns: JSON.parse(allowedColumnsJson),
      i18n: JSON.parse(i18nJson),
    }),
    datasource: new Datasource({
      callbacks: dataCallbacks,
      indexPath,
      limit: paginationPageSize,
    }),
    onColumnMoved(params) {
      updateColumnPositionsInCookies(columnOptions, params)
    },
  }
  return AgGrid.createGrid(gridElement, options);
}

export default class extends Controller {
  connect() {
    const gridElement = this.element.querySelector('#paymentsGrid');

    if (gridElement) {
      this.gridObject = buildGrid(gridElement, {})
    }
  }

  disconnect() {
    if (this.gridObject) {
      this.gridObject.destroy();
    }
  }
}
